export default __webpack_public_path__ + "static/media/cotton.4b652507.jpg";